import React from 'react';
import { Link } from 'react-router-dom';

import AlertBanner from '~/components/core/AlertBanner';

const DocumentTemplatesInfoBanner: React.FC = () => {
  return (
    <AlertBanner
      className="mb-12 mt-20"
      alertType={AlertBanner.ALERT_TYPES.INFO}
      withIcon
      title="Please Note"
      note={
        <span>
          Document templates can be customized using tokens anywhere you want to pre-populate information. For a
          complete list of available tokens, continue reading
          <Link to="/sysconfig/operations/generic_templates_configuration/tokens" className="pl-4">
            here
          </Link>
          .
        </span>
      }
    />
  );
};

export default DocumentTemplatesInfoBanner;
